import Cursor from "./mouse-cursor";
export const MouseCursor = new Cursor();
